import {
  REQUEST_MAIN_EXPERTS_SEARCH,
  RESPONSE_MAIN_EXPERTS_SEARCH,
  FAILURE_MAIN_EXPERTS_SEARCH,
  RESPONSE_MAIN_EXPERTS_SEARCH_TERMS,
  RESPONSE_MAIN_EXPERTS_SEARCH_TWEETS,
  RESPONSE_MAIN_EXPERTS_SEARCH_ORGS,
  UPDATE_MAIN_EXPERTS_SEARCH_SORT,
  TOGGLE_MAIN_EXPERTS_SAVE_MODE,
  UPDATE_MAIN_EXPERTS_SAVE_LIST_ITEMS,
  UPDATE_MAIN_EXPERTS_SAVE_LIST_TYPE,
  UPDATE_MAIN_EXPERT_TEMP_KEYWORDS,
  RESPONSE_MAIN_EXPERTS_SEARCH_DEFS,
} from "../../actions/types";

const initialState = {
  tempKeywords: [],
  isInitialScreen: true,
  isFetching: false,
  results: [],
  synonyms: [],
  resultKeywords: [],
  error: false,
  activePage: 1,
  size: 10,
  total: 0,
  relatedTerms: {
    close: [],
    distant: [],
  },
  defs: "",
  orgs: [],
  tweets: [],
  filters: {
    affs: [],
    year: new Date().getFullYear() - 10, // last 10 years filter
    country: [],
    partner: "false",
    experts: [],
    isClinician: "no",
    queryText: "",
  },
  keyword: "",
  keywords: [],
  totalArticles: 0,
  total: 0,
  sort: {
    name: "citation",
    order: "desc",
    type: "",
  },
  isSaveActive: false,
  selectedItems: {},
};

const updateTempKeywords = (state, action) => {
  let { tempKeywords } = action.payload;
  return {
    ...state,
    tempKeywords: tempKeywords || [],
  };
};

const setRequest = (state, action) => {
  let { keywords, filters, activePage } = action.payload;

  if (action.payload.isUpdate) {
    return {
      ...state,
      keywords,
    };
  }

  if (!filters) {
    filters = {
      year: "",
      country: [],
      partner: "false",
      experts: [],
      isClinician: "no",
      queryText: "",
    };
  }

  return {
    ...state,
    isFetching: true,
    error: false,
    isInitialScreen: false,
    results: [],
    synonyms: [],
    keywords: keywords,
    filters,
    relatedTerms: {
      close: [],
      distant: [],
    },
    orgs: [],
    tweets: [],
    defs: "",
    activePage,
    totalArticles: 0,
    total: 0,
    resultKeywords: keywords,
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    isInitialScreen: false,
    results: [],
    synonyms: [],
    relatedTerms: {
      close: [],
      distant: [],
    },
    orgs: [],
    tweets: [],
    defs: "",
    filters: {
      ...initialState.filters,
    },
  };
};

const setResponse = (state, action) => {
  let {
    results = [],
    synonyms = [],
    totalArticles,
    totalExperts,
    filters,
  } = action.payload;

  // synonyms = [...synonyms.slice(0, 5)];
  if (results.length === 0) {
    return {
      ...state,
      isFetching: false,
      error: false,
      results: results,
      isInitialScreen: false,
      totalArticles,
      total: totalExperts,
      results: [],
      relatedTerms: {
        close: [],
        distant: [],
      },
      orgs: [],
      tweets: [],
      defs: "",
      filters: {
        ...initialState.filters,
        filters,
      },
    };
  }

  // for mapping nested-sharedCit into intial-object
  results = results.map((l) => {
    let sharedCitObj = l?.sharedCit
      ? l?.sharedCit?.reduce(
          (acc, item) => ({ ...acc, [item?.key]: item?.value }),
          {},
        )
      : {};
    return {
      ...l,
      ...sharedCitObj,
    };
  });

  return {
    ...state,
    isFetching: false,
    error: false,
    results: results,
    synonyms: synonyms,
    isInitialScreen: false,
    totalArticles,
    total: totalExperts,
    filters,
  };
};

const setResponseTerms = (state, action) => {
  let relatedTerms = action.payload || {};
  let newRelatedTerms = {
    close: relatedTerms.close || [],
    distant: relatedTerms.distant || [],
  };
  return {
    ...state,
    relatedTerms: newRelatedTerms,
  };
};

const setResponseTweets = (state, action) => {
  let { tweets = [] } = action.payload;
  return {
    ...state,
    tweets: tweets,
  };
};

const setResponseDefs = (state, action) => {
  let { defs = "" } = action.payload;
  return {
    ...state,
    defs: defs,
  };
};

const setResponseOrgs = (state, action) => {
  let { orgs = [] } = action.payload;
  return {
    ...state,
    orgs: orgs,
  };
};

const setSort = (state, action) => {
  let sort = action.payload.sort || {
    name: "citation",
  };
  return {
    ...state,
    sort: sort,
  };
};

const handleSaveToggle = (state, action) => {
  return {
    ...state,
    isSaveActive: !state.isSaveActive,
    selectedItems: {},
    saveListType: "",
  };
};

const handleUpdateSaveListItems = (state, action) => {
  let selectedItems = action.payload.selectedItems || {};
  return {
    ...state,
    selectedItems: selectedItems,
  };
};

const updateSaveListType = (state, action) => {
  let saveListType = action.payload.saveListType;
  return {
    ...state,
    saveListType: saveListType,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESPONSE_MAIN_EXPERTS_SEARCH:
      return setResponse(state, action);
      break;

    case FAILURE_MAIN_EXPERTS_SEARCH:
      return setFailure(state, action);
      break;

    case REQUEST_MAIN_EXPERTS_SEARCH:
      return setRequest(state, action);

    case RESPONSE_MAIN_EXPERTS_SEARCH_TERMS:
      return setResponseTerms(state, action);
      break;

    case RESPONSE_MAIN_EXPERTS_SEARCH_TWEETS:
      return setResponseTweets(state, action);
      break;

    case RESPONSE_MAIN_EXPERTS_SEARCH_ORGS:
      return setResponseOrgs(state, action);
      break;

    case UPDATE_MAIN_EXPERTS_SEARCH_SORT:
      return setSort(state, action);

    case TOGGLE_MAIN_EXPERTS_SAVE_MODE:
      return handleSaveToggle(state, action);

    case UPDATE_MAIN_EXPERTS_SAVE_LIST_ITEMS:
      return handleUpdateSaveListItems(state, action);

    case UPDATE_MAIN_EXPERTS_SAVE_LIST_TYPE:
      return updateSaveListType(state, action);

    case RESPONSE_MAIN_EXPERTS_SEARCH_DEFS:
      return setResponseDefs(state, action);

    case UPDATE_MAIN_EXPERT_TEMP_KEYWORDS:
      return updateTempKeywords(state, action);

    default:
      return state;
      break;
  }
};
